import React from "react";
import AnchorTag from "../../library/baaShared/AnchorTag";
import ImageTag from "../../library/baaShared/ImageTag";
import ArrowLink from "../../library/baaShared/ArrowLink/ArrowLink";
import "./PageFooter.scss";
import { Input } from "reactstrap";
import CookieConsent from "../CookieConsent";

import  FooterLogo from "../../assets/IBAA_Tour_Logo_Black_CMYK.webp"

const PageFooter = props => {

  let { fields } = props;
  let copyrightText = fields && fields["Copyright Text"].value
  let socialList = fields && fields["Social Links"] ? fields["Social Links"] : []
  let navigationList = fields && fields["Quick Links"] ? fields["Quick Links"] : [];
  let isBookingPage = window.location.href.indexOf("tour-booking/") > -1;

  if (isBookingPage) {
    return null;
  }
  else {
    return (
      <footer className="footer-area full-bleed-component">
        <div className="footer-wrap">
           <hr className="footerline"></hr>
            {
                navigationList && navigationList.length > 0 ? (
                    <div className="social-wrapper">
                        <div className="social-icons">
                            {socialList.map((listSocialIcon, index) => {
                                let image = listSocialIcon.fields && listSocialIcon.fields["Social Icon"].value ? listSocialIcon.fields["Social Icon"].value : "";
                                let src = image && image.src ? image.src : "";
                                let alt = image && image.alt ? image.alt : "";
                                let link = listSocialIcon.fields && listSocialIcon.fields.Hyperlink && listSocialIcon.fields.Hyperlink.value
                                    && listSocialIcon.fields.Hyperlink.value.url ? listSocialIcon.fields.Hyperlink.value.url : "";


                                return (
                                    <AnchorTag
                                        key={index}
                                        aText={
                                            <ImageTag
                                                iSrc={src}
                                                iAlt={alt}
                                                height={"24px"}
                                                width={"24px"}

                                            />
                                        }
                                        aHref={link}
                                        aTarget="_blank"
                                    />
                                );
                            })}
                        </div>
                    </div>
                    )
                        : (
                        <div className="social-wrapper-nomenu">
                            <div className="social-icons">
                                {socialList.map((listSocialIcon, index) => {
                                    let image = listSocialIcon.fields && listSocialIcon.fields["Social Icon"].value ? listSocialIcon.fields["Social Icon"].value : "";
                                    let src = image && image.src ? image.src : "";
                                    let alt = image && image.alt ? image.alt : "";
                                    let link = listSocialIcon.fields && listSocialIcon.fields.Hyperlink && listSocialIcon.fields.Hyperlink.value
                                        && listSocialIcon.fields.Hyperlink.value.url ? listSocialIcon.fields.Hyperlink.value.url : "";
                                    return (
                                        <AnchorTag
                                            key={index}
                                            aText={
                                                <ImageTag
                                                    iSrc={src}
                                                    iAlt={alt}
                                                    height={"24px"}
                                                    width={"24px"}

                                                />
                                            }
                                            aHref={link}
                                            aTarget="_blank"
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    )
            }
           <div className="logo1 logo1-new">                   
                <a href= {
                            !window.location.pathname.includes("tour-booking/")
                                ? ""
                                : "/en"
                        }>
                <img src={FooterLogo}
                />
                </a>
           </div>
           {
                    navigationList && navigationList.length > 0 ? (
                      <div className="footer-links-wrapper">
                        <div className="footer-links">
                          {/* <div className="left-sided">
                            <ul className="link-area">
                              {                                    
                                navigationList.map((listItem, index) => {
                                if (index < 3) {
                                  
                                  let secFields = listItem.fields ? listItem.fields : "";
                                  let NavigationTitle = secFields && secFields["Link Title"] ? secFields["Link Title"].value : "";
                                  let link = secFields && secFields.Hyperlink && secFields.Hyperlink.value ? secFields.Hyperlink.value.href : "";

                                  return (
                                    <li key={index} className="f-link">
                                      <AnchorTag
                                        aText={NavigationTitle}
                                        aHref={link}
                                      />
                                    </li>
                                  );
                                } else {
                                  return "";
                                }
                                })
                              }
                            </ul>
                          </div>
                          <div className="right-sided">
                            <ul className="link-area">
                              {
                                navigationList && navigationList.map((listItem, index) => {
                                let secFields = listItem.fields ? listItem.fields : "";
                                let NavigationTitle = secFields && secFields["Link Title"] ? secFields["Link Title"].value : "";
                                let link = secFields && secFields.Hyperlink && secFields.Hyperlink.value ? secFields.Hyperlink.value.href : "";
                                let aTarget = secFields && secFields.Hyperlink && secFields.Hyperlink.value ? secFields.Hyperlink.value.target : "";
                                if (index >= 3 && index < 5) {

                                  return (
                                    <li key={index} className="f-link">
                                      <AnchorTag
                                        aText={NavigationTitle}
                                        aHref={link}
                                        aTarget={aTarget}
                                      />
                                    </li>
                                  );
                                } else {
                                  return "";
                                }
                              })}
                            </ul>
                          </div>
                          <div className="end-sided">
                            <ul className="link-area">
                               {
                                navigationList && navigationList.map((listItem, index) => {
                                let secFields = listItem.fields ? listItem.fields : "";
                                let NavigationTitle = secFields && secFields["Link Title"] ? secFields["Link Title"].value : "";
                                let link = secFields && secFields.Hyperlink && secFields.Hyperlink.value ? secFields.Hyperlink.value.href : "";
                                let aTarget = secFields && secFields.Hyperlink && secFields.Hyperlink.value ? secFields.Hyperlink.value.target : "";
                                if (index >= 5 && index <= 7) {

                                  return (
                                    <li key={index} className="f-link">
                                      <AnchorTag
                                        aText={NavigationTitle}
                                        aHref={link}
                                        aTarget={aTarget}
                                      />
                                    </li>
                                  );
                                } else {
                                  return "";
                                }
                              })}
                            </ul>
                          </div> */}
                          
                          <ul class="link-area">
                            {
                              (fields["Quick Links"]).map((i) => 
                                <li class="f-link">
                                    <a href={i.fields.Hyperlink.value.href}>
                                      {i.fields['Link Title'].value}
                                    </a>
                                </li>
                              )
                            }
                          </ul>
                      </div>
                      <div className="copyright-text" dangerouslySetInnerHTML={{ __html: copyrightText }} />
                    </div>
                    ) : (
                            <div className="partner-copyright-text-nomenu" dangerouslySetInnerHTML={{ __html: copyrightText }} />
                    )
           }
        </div>
        <div className="home-page-popups">
          <CookieConsent data={props.fields} />
        </div>
      </footer>
    );
  }
};

export default PageFooter;
